import React, { Component } from 'react';
import { Row } from 'react-flexbox-grid';
import InvoicesTable from './InvoicesTable';
import { connect } from 'react-redux';
import { invoicesSelector } from '../../../routes/Account/selectors';

import api from '../../../utils/api';

import 'isomorphic-fetch';

class Invoices extends Component {
    componentDidMount = () => {
        this.props.fetchInvoices();
    };

    generateInvoicePDF = ({ id, contractId }) => {};

    render() {
        return (
            <Row>
                <InvoicesTable
                    invoices={this.props.invoices}
                    generateInvoicePDF={this.props.generateInvoicePDF}
                />
            </Row>
        );
    }
}

const mapStateToProps = (state, props) => ({
    isFetching: state.invoices.get('isFetching'),
    invoices: invoicesSelector(state),
});

const mapDispatchToProps = dispatch => ({
    fetchInvoices: () => dispatch(api.actions.invoices.fetchInvoices()),
    generateInvoicePDF: payload => dispatch(api.actions.invoices.generateInvoicePDF(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Invoices);
